/**
 *  ・定義ファイル役割
 *    共通エラーメッセージ
 *  ・概要
 *    画面共通で使用するエラーメッセージを定義
 *  ・更新履歴
 *    2021/05/25 新規作成 佐藤
 */

export const DefaultErrorCode = 'SYSTEM_ERROR';
export const NetworkErrorCode = 'NETWORK_ERROR';
export const RoleErrorCode = 'NO_PRIVILEGES';
export const NetworkErrorStatus = 0;

export const ErrorCode: {[api: string]: {[code: string]: string}} = {
  // ExecuteActionAPIのエラーメッセージ（一括処理でも使用）
  EXECUTEACTION: {
    ITEM_REV_CONFLICT: '他のユーザーがデータを変更したため処理に失敗しました',
    INVALID_VALUE: '登録、更新のために指定されたデータが不正です',
    INVALID_SETTINGS: '設定値にエラーがあるため、処理を継続できません',
    NOT_FOUND: '指定された値が見つかりません',
    PROCESS_STOPPED: '処理が中断されました',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    SYSTEM_ERROR: 'システムエラーが発生いたしました',
    NETWORK_ERROR: 'が発生しました。再度操作を行ってください。'
  },
  // CreateItemAPIのエラーメッセージ（一括処理でも使用）
  CREATEITEM: {
    ITEM_REV_CONFLICT: '他のユーザーがデータを変更したため処理に失敗しました',
    INVALID_VALUE: '登録、更新のために指定されたデータが不正です',
    INVALID_SETTINGS: '設定値にエラーがあるため、処理を継続できません',
    INVALID_PARAMS: '指定されたパラメータが正しくありません',
    NOT_FOUND: '指定された値が見つかりません',
    PROCESS_STOPPED: '処理が中断されました',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  // GetDatastoreFieldsAPIのエラーメッセージ
  GETDATASTOREFIELDS: {
    NOT_FOUND: '対象データベースが見つかりません',
    INVALID_PARAMS: '指定されたパラメータが正しくありません',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    INVALID_SETTINGS: '	設定値にエラーがあるため、処理を継続できません',
    PROCESS_STOPPED: '処理が中断されました',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  // GetItemSearchConditionsAPIのエラーメッセージ
  GETITEMSEARCHCONDITIONS: {
    NOT_FOUND: '対象データベースが見つかりません',
    INVALID_PARAMS: '指定されたパラメータが正しくありません',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    INVALID_SETTINGS: '	設定値にエラーがあるため、処理を継続できません',
    PROCESS_STOPPED: '処理が中断されました',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  // ItemListAPIのエラーメッセージ
  ITEMLIST: {
    INVALID_PARAMS: '不正なパラメータが含まれています',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    INVALID_SETTINGS: '	設定値にエラーがあるため、処理を継続できません',
    PROCESS_STOPPED: '処理が中断されました',
    SEARCH_TIMEOUT: 'データの取得がタイムアウトしました',
    COUNT_TIMEOUT: '件数の取得がタイムアウトしました',
    NOT_FOUND: 'データは見つかりませんでした',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  // GetItemDetailsAPIのエラーメッセージ
  GETITEMDETAILS: {
    NOT_FOUND: '対象アイテムが見つかりません',
    INVALID_PARAMS: '不正なパラメータが含まれています',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    INVALID_SETTINGS: '	設定値にエラーがあるため、処理を継続できません',
    PROCESS_STOPPED: '処理が中断されました',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  // GetNewActionsAPIのエラーメッセージ
  GETNEWACTIONS: {
    INVALID_PARAMS: '対象が見つかりません',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    INVALID_SETTINGS: '	設定値にエラーがあるため、処理を継続できません',
    PROCESS_STOPPED: '処理が中断されました',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  // GetInputFieldsAPIのエラーメッセージ
  GETINPUTFIELDS: {
    NOT_FOUND: '対象処理が見つかりません',
    INVALID_PARAMS: '不正なパラメータが含まれています',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    INVALID_SETTINGS: '	設定値にエラーがあるため、処理を継続できません',
    PROCESS_STOPPED: '処理が中断されました',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  // GetReportDataByConditionsAPIのエラーメッセージ
  GETREPORTDATABYCONDITIONS: {
    INVALID_PARAMS: '不正なパラメータが含まれています',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    INVALID_SETTINGS: '	設定値にエラーがあるため、処理を継続できません',
    PROCESS_STOPPED: '処理が中断されました',
    SEARCH_TIMEOUT: 'データの取得がタイムアウトしました',
    COUNT_TIMEOUT: '件数の取得がタイムアウトしました',
    NOT_FOUND: 'データは見つかりませんでした',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  // AutoNumberAPIのエラーメッセージ
  AUTONUMBER: {
    NOT_FOUND: '対象データベースが見つかりません',
    INVALID_PARAMS: '指定されたパラメータが正しくありません',
    NO_PRIVILEGES: 'ログインユーザに権限がありません',
    INVALID_SETTINGS: '	設定値にエラーがあるため、処理を継続できません',
    PROCESS_STOPPED: '処理が中断されました',
    SYSTEM_ERROR: 'システムエラーが発生いたしました'
  },
  DEFAULT: {
    SYSTEM_ERROR: 'システムエラーが発生いたしました',
    NETWORK_ERROR: 'が発生しました。再度操作を行ってください。',
    NO_PRIVILEGES: 'ログインユーザに権限がありません'
  }
}